import React, { useEffect, useState } from "react";
import AdminDashboard from "../AdminDashboard";
import { Alert, Button, Col, Form, Row, Spinner } from "react-bootstrap";
import { useParams } from "react-router-dom";
import axios from "axios";
import { basicConfigMultipart } from "../../../constants";
import { gmtDate, localizeDate } from "../../../methods/formatDate";
import LineItemContainer from "./LineItemContainer";

const CustomerOrderDetail = () => {
  const { id } = useParams();

  const [loading, setLoading] = useState(false);

  const [showError, setShowError] = useState(false);

  const [order, setOrder] = useState(null);

  useEffect(() => {
    const fetchOrderDetail = async () => {
      setShowError(false);
      setLoading(true);

      await axios
        .get(
          `${process.env.REACT_APP_API_URL}/orders/order/${id}/`,
          basicConfigMultipart
        )
        .catch((_) => {
          setShowError(true);
        })
        .then((response) => {
          if (response && response.status === 200) {
            setOrder(response.data);
          } else {
            setShowError(true);
          }
        });

      setLoading(false);
    };

    fetchOrderDetail();
  }, [id]);

  const [showPayError, setShowPayError] = useState(false);

  const [payFormData, setPayFormData] = useState({
    payment_method: null,
    needs_payment: false,
    date_paid_gmt: null,
    transaction_ref: null,
  });

  //   const { payment_method, date_paid_gmt, transaction_ref } = payFormData;

  const onPayChange = (e) =>
    setPayFormData({ ...payFormData, [e.target.name]: e.target.value });

  async function payOrder(e) {
    e.preventDefault();
    setLoading(true);
    await axios
      .patch(
        `${process.env.REACT_APP_API_URL}/orders/order/${id}/`,
        payFormData,
        basicConfigMultipart
      )
      .catch((_) => {
        setShowPayError(true);
      })
      .then((response) => {
        if (response && response.status === 200) {
          setLoading(false);
          setOrder(response.data);
        } else {
          setLoading(false);
          setShowPayError(true);
        }
      });
    setLoading(false);
  }

  async function updateStatus(status) {
    setLoading(true);
    await axios
      .patch(
        `${process.env.REACT_APP_API_URL}/orders/order/${id}/`,
        { status: status },
        basicConfigMultipart
      )
      .catch((_) => {
        setShowPayError(true);
      })
      .then((response) => {
        if (response && response.status === 200) {
          setLoading(false);
          setOrder(response.data);
        } else {
          setLoading(false);
          setShowPayError(true);
        }
      });
    setLoading(false);
  }

  return (
    <AdminDashboard>
      <>
        {showError && (
          <Alert
            variant="danger"
            onClose={() => {
              setShowError(false);
            }}
            dismissible
          >
            <Alert.Heading>Error fetching.</Alert.Heading>
          </Alert>
        )}
        {loading && <Spinner animation="grow" />}
        <div className="admin_content">
          <div className="admin_content_header">
            <h4>Order Detail : # {order?.id}</h4>
          </div>

          <div className="admin_content_content">
            <Row className="admin_order_detail">
              <Col sm={6}>
                <Form>
                  <Form.Group className="mb-3">
                    <Form.Label>Customer </Form.Label>
                    <Form.Control
                      type="text"
                      value={order?.customer ?? ""}
                      disabled
                    />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label>Date Created </Form.Label>
                    <Form.Control
                      type="text"
                      value={
                        order?.date_created_gmt != null
                          ? localizeDate(order?.date_created_gmt)
                          : ""
                      }
                      disabled
                    />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label>Status </Form.Label>
                    <Form.Control
                      type="text"
                      value={order?.status ?? ""}
                      disabled
                    />
                  </Form.Group>
                  {order?.date_completed_gmt != null && (
                    <Form.Group className="mb-3">
                      <Form.Label>Date Completed </Form.Label>
                      <Form.Control
                        type="text"
                        value={
                          order?.date_completed_gmt != null
                            ? localizeDate(order?.date_completed_gmt)
                            : ""
                        }
                        disabled
                      />
                    </Form.Group>
                  )}
                  <Form.Group className="mb-3">
                    <Form.Label>Created Via </Form.Label>
                    <Form.Control
                      type="text"
                      value={order?.created_via ?? ""}
                      disabled
                    />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label>Shipping </Form.Label>
                    <Form.Control
                      type="number"
                      value={order?.shipping_total ?? 0}
                      disabled
                    />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label>Tax </Form.Label>
                    <Form.Control
                      type="number"
                      value={order?.total_tax ?? 0}
                      disabled
                    />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label>Discount </Form.Label>
                    <Form.Control
                      type="number"
                      value={order?.discount ?? 0}
                      disabled
                    />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <Form.Label>Total </Form.Label>
                    <Form.Control
                      type="number"
                      value={order?.total ?? 0}
                      disabled
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Check
                      type="checkbox"
                      label="Paid"
                      checked={
                        !(order?.needs_payment ?? true) &&
                        order?.date_paid_gmt != null
                      }
                      disabled
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Pay Method </Form.Label>
                    <Form.Control
                      type="text"
                      value={order?.payment_method ?? ""}
                      disabled
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Transaction Ref. </Form.Label>
                    <Form.Control
                      type="text"
                      value={order?.transaction_ref ?? ""}
                      disabled
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label>Date Paid </Form.Label>
                    <Form.Control
                      type="text"
                      value={
                        order?.date_paid_gmt != null
                          ? localizeDate(order?.date_paid_gmt)
                          : ""
                      }
                      disabled
                    />
                  </Form.Group>
                  <Form.Group className="mb-3">
                    <label htmlFor="description">Customer Note</label>
                    <textarea
                      name="customer_note"
                      className="form-control"
                      disabled
                      value={order?.customer_note ?? ""}
                      rows={4}
                    ></textarea>
                  </Form.Group>
                  {order?.shipping?.id != null && (
                    <>
                      <Form.Group className="mb-3">
                        <Form.Label>Shipping Address </Form.Label>
                        <Form.Control
                          type="text"
                          value={
                            order?.shipping?.address +
                            ", " +
                            order?.shipping?.town
                          }
                          disabled
                        />
                      </Form.Group>
                      <Form.Group className="mb-3">
                        {/* <Form.Label></Form.Label> */}
                        <Form.Control
                          type="text"
                          value={
                            order?.shipping?.county +
                            ", " +
                            order?.shipping?.country
                          }
                          disabled
                        />
                      </Form.Group>
                    </>
                  )}
                </Form>
              </Col>
              <Col>
                {/* line items */}
                {(order?.line_items ?? []).map((lineItem, index) => {
                  return <LineItemContainer lineItem={lineItem} key={index} />;
                })}
              </Col>
            </Row>
            <br />
            <br />

            {/*  */}
            {/* pay order */}
            {order?.needs_payment && (
              <Row>
                <Col sm={6}>
                  <Form onSubmit={(e) => payOrder(e)}>
                    <h5>Make Payment</h5>
                    {showPayError && (
                      <Alert
                        variant="danger"
                        onClose={() => {
                          setShowPayError(false);
                        }}
                        dismissible
                      >
                        <Alert.Heading>Error paying.</Alert.Heading>
                      </Alert>
                    )}

                    <Form.Group className="mb-3">
                      <Form.Select
                        aria-label="Default select example"
                        onChange={(e) => onPayChange(e)}
                        name="payment_method"
                        required
                      >
                        <option value="">Select Payment Method</option>
                        <option value="Cash">Cash</option>
                        <option value="Mpesa Direct">Mpesa Direct</option>
                        <option value="Buy Goods Till">Buy Goods Till</option>
                        <option value="Pay Bill">Pay Bill</option>
                      </Form.Select>
                    </Form.Group>
                    <Form.Group className="mb-3">
                      <Form.Label>Transaction Ref. </Form.Label>
                      <Form.Control
                        type="text"
                        name="transaction_ref"
                        onChange={(e) => onPayChange(e)}
                      />
                    </Form.Group>
                    <Form.Group className="mb-3">
                      <Form.Label>Date Paid </Form.Label>
                      <Form.Control
                        type="datetime-local"
                        required
                        name="date_paid_gmt"
                        onChange={(e) => {
                          setPayFormData({
                            ...payFormData,
                            [e.target.name]: gmtDate(e.target.value),
                          });
                        }}
                      />
                    </Form.Group>

                    {/* <FormTextField
                    type="datetime-local"
                    label={"Event Start DateTime"}
                    name={"start_date"}
                    disabled={selectedClubEvent != null}
                    value={start_date && valuefyDate(start_date)}
                    required={true}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        [e.target.name]: gmtDate(e.target.value),
                      })
                    }
                  /> */}
                    <Button type="submit">PAY ORDER</Button>
                  </Form>
                </Col>
              </Row>
            )}
            <br />
            <br />

            {/* change order status */}
            <Row>
              <Col>
                <Button
                  variant="success"
                  disabled={
                    order?.status === "completed" ||
                    order?.status === "cancelled" ||
                    order?.status === "refunded" ||
                    order?.status === "failed" ||
                    order?.status === "trash"
                  }
                  onClick={(_) => updateStatus("completed")}
                >
                  Complete Order
                </Button>
              </Col>

              <Col>
                <Button
                  variant="warning"
                  disabled={
                    order?.status === "completed" ||
                    order?.status === "cancelled" ||
                    order?.status === "refunded" ||
                    order?.status === "failed" ||
                    order?.status === "trash"
                  }
                  onClick={(_) => updateStatus("cancelled")}
                >
                  Cancel Order
                </Button>
              </Col>
              <Col>
                <Button
                  variant="warning"
                  disabled={
                    order?.status === "completed" ||
                    order?.status === "cancelled" ||
                    order?.status === "refunded" ||
                    order?.status === "failed" ||
                    order?.status === "trash"
                  }
                  onClick={(_) => updateStatus("trash")}
                >
                  Trash Order
                </Button>
              </Col>
              <Col></Col>
            </Row>
          </div>
        </div>
      </>
    </AdminDashboard>
  );
};

export default CustomerOrderDetail;
